<template>
	<div class="ChangePassword">
		<div v-if="!searchingToken" class="position-abolute">
			<password-form ref="passwordForm" :token="token" back="/access"></password-form>
		</div>
		<div v-else>
			<div class="alert alert-info text-center" role="alert" v-if="!errorToken">
				Estamos buscando su información
			</div>
			<div class="alert alert-warning text-center" role="alert" v-else>
				Algo falló, lo vamos a redireccionar a control de acceso
			</div>
		</div>
		<div class="text-center text-secondary">
			Suscripciones ACES Chile
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosSystem from '@/mixins/axiosSystem.js'
	import client from '@/mixins/client.js'

	import PasswordForm from '@/components/PasswordForm.vue'

	export default {
		name: 'ChangePassword',
		mixins: [mixin, client, axiosSystem],
		props: ['token'],
		data() {
			return {
				searchingToken: false,
				errorToken: false,
			}
		},
		components: {
			'password-form': PasswordForm
		},
		computed: {
		},
		methods: {
			initComponentLocal() {
				this.checkTokenClient(this.token)
			},
			checkTokenClientResultLocal(response) {
				if(response.data.success == true) {
					this.setObjectClient(response.data.data)
					this.messageSelected = (this.objectClient.password) ? 1 : 0
					this.searchingToken = false
					setTimeout(() => {
						this.$refs.passwordForm.$refs.btnCheckTokenClient.click()
					}, 100)
				} else {
					this.errorToken = true
					setTimeout(() => {
						this.$router.push('/access')
					}, 3000)
				}
			}
		},
		mounted () {
			this.initComponentLocal()
		}
	}
</script>
